<template>
    <div class="tabs">
        <ul class="nav nav-tabs">
            <li v-for="(tab, index) in tabs" class="nav-item" :key="index">
                <router-link tag="a"
                            :to="{name: tab.routeName}"
                            class="nav-link"
                            :class="{ active: isCurrentRoute(tab.routeName) }">
                    <i>
                        {{ tab.name }}
                    </i>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'TabCollection',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
    },
    methods: {
        isCurrentRoute(routeName) {
            return this.$route.name === routeName
        },
    }
}
</script>